import React, { useContext } from "react";
import MyContext from "../context/MyContext";
import { useForm } from "react-hook-form";
import {
  updateDelAddress,
  addDelAddress,
  setDefaultAddress,
} from "../helpers/apiCalls";
import { Avatar } from "@material-ui/core";
import logo from "../assets/01.jpg";

const Dashboard = () => {
  const { register, handleSubmit, reset } = useForm();
  const { user, setUser, billAddressId, setBillAddressId } =
    useContext(MyContext);

  const onSubmit = async (data) => {
    if (billAddressId) {
      const res = await updateDelAddress(user._id, billAddressId, data);
      setUser(res);
    } else {
      const res = await addDelAddress(user._id, data);
      setUser(res);
    }
    reset({});
  };

  const clear = () => {
    setBillAddressId(null);
    reset({});
  };

  const settingDefault = async (did) => {
    const result = await setDefaultAddress(user._id, did);
    setUser(result);
  };

  // console.log("user", user)
  return (
    <div className="user-dashboard">
      <div className="profie-address">
        <div className="profile">
          <Avatar style={{ margin: "0 auto" }} alt={logo} src={user?.avatar} />
          <h3>{user.fullName}</h3>
          <p>{user.email}</p>
          <p>{user.contactNumber}</p>
        </div>
        <div className="profile address">
          <h2>Bill Address</h2>
          {user.billAddress && (
            <>
              <h3>{user.billAddress.fullName}</h3>
              <p>{user.billAddress.streetno}</p>
              <p>{user.billAddress.postcity}</p>
              <p>{user.billAddress.country}</p>
            </>
          )}
        </div>
      </div>
      <div className="bill-address-form">
        <div className="delivery-address">
          <h2>Delivery Address</h2>

          {user.deliveryaddress?.map((address) => {
            return (
              <div className="bill-address" key={address._id}>
                <h3>{address.fullName}</h3>
                <p>{address.streetno}</p>
                <p>{address.postcity}</p>
                <p>{address.country} </p>
                <p>Last Update: {address.updatedAt} </p>
                <div className="bill-address-button">
                  <button
                    onClick={() => {
                      setBillAddressId(address._id);
                      reset(address);
                    }}
                  >
                    Update
                  </button>
                  <button onClick={() => settingDefault(address._id)}>
                    set Default
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <h2>{billAddressId ? "Update" : "Add"} Delivery address</h2>
          <div className="bill-address">
            <input
              placeholder="Full Name"
              {...register("fullName", {
                required: true,
              })}
            />
            <input
              placeholder="Street"
              {...register("street", {
                required: true,
              })}
            />
            <input
              placeholder="House Number"
              {...register("houseNo", {
                required: true,
              })}
            />
            <input
              placeholder="PostCode"
              {...register("postCode", {
                required: true,
              })}
            />
            <input
              placeholder="City"
              {...register("city", {
                required: true,
              })}
            />
            <input
              placeholder="Country"
              {...register("country", {
                required: true,
              })}
            />
            <div className="submit">
              {(user?.deliveryaddress.length >= 3 && !billAddressId) || (
                <button className="button-bg" type="submit">
                  Save
                </button>
              )}
              <button className="button-bg" type="button" onClick={clear}>
                Clear
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Dashboard;
